<template>
  <div class="modal">
    <div class="modal__background" @click="$emit('cancel')"></div>
    <new-submission class="modal__content" />
  </div>
</template>

<script>
import NewSubmission from './NewSubmission';
export default {
  name: 'UploadModal',
  components: { NewSubmission },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  display: flex;
  height: 100vh;
  width: 100vw;
  left: 0;
  top: 0;
  z-index: 100;

  &__background {
    position: absolute;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(6px);
  }

  &__content {
    transform: translateY(-25%);
  }
}
</style>
